<template>
  <div>
    <el-button id="selectfiles" :type="type" icon="el-icon-upload">
      <slot />
    </el-button>
  </div>
</template>

<script>
  import md5 from 'js-md5'
  export default {
    name: "uploadoss",
    props:{
      type: {
        type: String,
        default: "default"
      }
    },
    mounted(){
      this.exUpload();
    },
    methods:{
      exUpload(){   
        var _this = this;
        let accessid = ''
        // let accesskey = ''
        let host = ''
        let policyBase64 = ''
        let signature = ''
        let callbackbody = ''
        let callback = ''
        let filename = ''
        let key = ''
        let expire = 0
        let g_object_name = ''
        let g_object_name_type = ''
        let now = Date.parse(new Date()) / 1000; 
        let timestamp = now;
        let suffix = ""
        let file_url = ""
        
        function send_request()
        {
            var xmlhttp = null;
            if (window.XMLHttpRequest)
            {
                xmlhttp=new XMLHttpRequest();
            }
            else if (window.ActiveXObject)
            {
                xmlhttp=new window.ActiveXObject("Microsoft.XMLHTTP");
            }
          
            if (xmlhttp!=null)
            {
                if (filename!='') {
                  suffix = get_suffix(filename)
                }
                // serverUrl是 用户获取 '签名和Policy' 等信息的应用服务器的URL，请将下面的IP和Port配置为您自己的真实信息。
                // serverUrl = 'http://88.88.88.88:8888/aliyun-oss-appserver-php/php/get.php'
                var serverUrl = '/general/attachment/getOssAuth';
            
                xmlhttp.open( "GET", serverUrl, false );
                xmlhttp.send( null );
                return xmlhttp.responseText
            }
            else
            {
                alert("Your browser does not support XMLHTTP.");
            }
        }
        function base64Encode(str) {
                    var keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                    var output = "";
                    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
                    var i = 0;
                    str = utf8Encode(str);
                    while (i < str.length) {
                        chr1 = str.charCodeAt(i++);
                        chr2 = str.charCodeAt(i++);
                        chr3 = str.charCodeAt(i++);
                        enc1 = chr1 >> 2;
                        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                        enc4 = chr3 & 63;
                        if (isNaN(chr2)) {
                            enc3 = enc4 = 64;
                        } else if (isNaN(chr3)) {
                            enc4 = 64;
                        }
                        output = output +
                            keyStr.charAt(enc1) + keyStr.charAt(enc2) +
                            keyStr.charAt(enc3) + keyStr.charAt(enc4);
                    }
                    return output;
        }
        function utf8Encode(string) {
                    string = string.replace(/\r\n/g,"\n");
                    var utftext = "";
                    for (var n = 0; n < string.length; n++) {
                        var c = string.charCodeAt(n);
                        if (c < 128) {
                            utftext += String.fromCharCode(c);
                        } else if ((c > 127) && (c < 2048)) {
                            utftext += String.fromCharCode((c >> 6) | 192);
                            utftext += String.fromCharCode((c & 63) | 128);
                        } else {
                            utftext += String.fromCharCode((c >> 12) | 224);
                            utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                            utftext += String.fromCharCode((c & 63) | 128);
                        }
                    }
                    return utftext;
        }
        function check_object_radio() {
            g_object_name_type = 'random_name';
            // var tt = document.getElementsByName('myradio');
            // for (var i = 0; i < tt.length ; i++ )
            // {
            //     if(tt[i].checked)
            //     {
            //         g_object_name_type = tt[i].value;
            //         break;
            //     }
            // }
        }
        
        function get_signature()
        {
            // 可以判断当前expire是否超过了当前时间， 如果超过了当前时间， 就重新取一下，3s 作为缓冲。
            now = timestamp = Date.parse(new Date()) / 1000; 
            if (expire < now + 3)
            {
                var body = send_request()
                var obj = eval ("(" + body + ")");
                // host = "https://dev-qushanghui.oss-cn-beijing.aliyuncs.com"//obj['host']
                host = obj['host']
                policyBase64 = obj['policy']
                accessid = obj['accessid']
                signature = obj['signature']
                expire = parseInt(obj['expire'])
                callbackbody = obj['callbackBody'] 
                key = obj['dir']
                file_url = obj['file_url']
                return true;
            }
            return false;
        }
        
        function getRnd(min, max){
                    return Math.floor(Math.random() * (max - min + 1)) + min
        }
        function uuid() {
          return md5(Date.now() + '_' + getRnd(10000000,100000000));
        }

        function get_suffix(filename) {
            var pos = filename.lastIndexOf('.')
            suffix = ''
            if (pos != -1) {
                suffix = filename.substring(pos)
            }
            return suffix;
        }
        
        function calculate_object_name(filename)
        {
            if (g_object_name_type == 'local_name')
            {
                g_object_name += "${filename}"
            }
            else if (g_object_name_type == 'random_name')
            {
                suffix = get_suffix(filename)
                g_object_name = key + uuid() + suffix
            }
            return ''
        }
        
        function get_uploaded_object_name(filename)
        {
            if (g_object_name_type == 'local_name')
            {
                var tmp_name = g_object_name
                tmp_name = tmp_name.replace("${filename}", filename);
                return tmp_name
            }
            else if(g_object_name_type == 'random_name')
            {
                return g_object_name
            }
        }
        function getFileName(name){
                    var arr = name.split(".");
                    return (arr[arr.length-2]);
        }
        function set_upload_param(up, file)
        {
              suffix = get_suffix(file.name)
              calculate_object_name(file.name)
              // g_object_name = key;
              if(g_object_name.indexOf('/')===0){
                g_object_name = g_object_name.slice(1);
              }
              callback = typeof callbackbody === 'object' ? callbackbody : JSON.stringify(callbackbody);
              callback.callbackBody =  callback.callbackBody + '&file_name='+getFileName(file.name)+ '&file_type='+file.type;
              var new_multipart_params = {
                  'key' : g_object_name,
                  'policy': policyBase64,
                  'OSSAccessKeyId': accessid, 
                  'success_action_status' : '200', //让服务端返回200,不然，默认会返回204
                  'callback' : base64Encode(JSON.stringify(callback)),
                  'signature': signature,
              };
          
              up.setOption({
                  'url': host,
                  'multipart_params': new_multipart_params
              });
            up.start();
        }
        
        var uploader = new window.plupload.Uploader({
			 runtimes : 'html5,flash,silverlight,html4',
			 browse_button : 'selectfiles', 
			 //multi_selection: false,
			 //container: document.getElementById('container'),
			 flash_swf_url : 'lib/plupload-2.1.2/js/Moxie.swf',
			 silverlight_xap_url : 'lib/plupload-2.1.2/js/Moxie.xap',
			 resize: {
				preserve_headers: false,
			},
            url : 'http://oss.aliyuncs.com',
            filters: {
                mime_types : [ //只允许上传图片和zip文件
                { title : "Image files", extensions : "jpg,png,bmp,jpeg,gif" }, 
                { title : "Zip files", extensions : "zip,rar" }
                ],
				//max_file_size : '10mb', //最大只能上传10mb的文件
                prevent_duplicates : true //不允许选取重复文件
            },
        
          init: {
            PostInit: function() {
            },
        
            FilesAdded: function(up, files) {
              _this.$emit('filesAdded', {
                up,
                files
              });
              get_signature();
              up.start();
            },
        
            BeforeUpload: function(up, file) {
                    check_object_radio();
                    set_upload_param(up, file);
                },
        
            UploadProgress: function(up, file) {
              _this.$emit('progress', {
                up,
                file
              });
            },
        
            FileUploaded: function(up, file, info) {
              _this.$emit('fileUploaded', {
                up,
                file,
                info,
                filename: get_uploaded_object_name(file.name),
                url: file_url+'/'+get_uploaded_object_name(file.name)
              });
            },
        
            Error: function(up, err) {
                    if (err.code == -600) {
                        // document.getElementById('console').appendChild(document.createTextNode("\n选择的文件太大了,可以根据应用情况，在upload.js 设置一下上传的最大大小"));
                        _this.$message.error('文件不能大于10M');
                    }
                    else if (err.code == -601) {
                        // document.getElementById('console').appendChild(document.createTextNode("\n选择的文件后缀不对,可以根据应用情况，在upload.js进行设置可允许的上传文件类型"));
                        _this.$message.error('文件类型错误,只能上jpg,gif,png,bmp,zip,rar');
                    }
                    else if (err.code == -602) {
                        // document.getElementById('console').appendChild(document.createTextNode("\n这个文件已经上传过一遍了"));
                        _this.$message.error("文件已存在")
                    }
                    else 
                    {
                        // document.getElementById('console').appendChild(document.createTextNode("\nError xml:" + err.response));
                        _this.$message.error("\nError xml:" + err.response)
                    }
            }
          }
        });
        
        uploader.init();
      }
    }
  };
</script>

<style>
</style>
